/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Messenger from "App/messenger";
import IScene from "js_interface/src/scene_interface";

export default
class ProgressDispatchHelper {

    private _sceneAPI: IScene;
    private _name: string;
    private _size: number;
    private _progress: number;
    private _updateIntervalMs: number;

    private _id: number;
    private _dispatchNextProgress: boolean;

    constructor(aSceneAPI: IScene, aName: string, aSize: number, aUpdateIntervalMs: number) {

        this._sceneAPI = aSceneAPI;
        this._name = aName;
        this._size = aSize;
        this._progress = 0;
        this._updateIntervalMs = aUpdateIntervalMs;

        this._id = new Date().getTime();
        this._dispatchNextProgress = true;
    }

    public start(): void {

        Messenger.fireCDWKEvent(this._sceneAPI.getTargetTag(), "cwx3d_progressStart", {
            id: this._id,
            name: this._name,
            progress: 0
        });

        this._dispatchNextProgress = true;
    }

    public update(aValue: number): void {

        this._progress = aValue;

        // dispatch the event every second
        if (this._dispatchNextProgress) {
            window.setTimeout((): void => {
                Messenger.fireCDWKEvent(this._sceneAPI.getTargetTag(), "cwx3d_progressChanged", {
                    id: this._id,
                    name: this._name,
                    progress: (this._progress / this._size) * 100.0
                });
            }, this._updateIntervalMs);
        }

        this._dispatchNextProgress = false;
    }

    public finish(): void {
        window.setTimeout((): void => {
            Messenger.fireCDWKEvent(this._sceneAPI.getTargetTag(), "cwx3d_progressFinished", {
                id: this._id,
                name: this._name,
                progress: 100
            });
        }, this._updateIntervalMs);
    }
}

